import { AxiosRequestConfig } from 'axios';

import { HttpClient } from '@httpClient/index';
import Methods from './methods';
import ActionNames from './actionNames';

class WorkflowService extends HttpClient<ActionNames> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public constructor(request: any, options?: AxiosRequestConfig) {
    super(request, options);

    this.init();
  }

  private init = (): void => {
    this.requests[ActionNames.TRANSITION_BY_STATE_FROM_INDEX] = this.request({
      method: Methods.TRANSITION_BY_STATE_FROM_INDEX,
    });
  };
}

export default WorkflowService;
